var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3C6.35813 3 3 6.10875 3 9.94438C3.02187 12.1631 4.10875 14.1231 5.77375 15.34L5.79312 15.3531V18L8.34812 16.5987C8.9925 16.7831 9.7325 16.8888 10.4975 16.8888H10.5C14.6419 16.8888 18 13.7794 18 9.945C18 6.11063 14.6419 3 10.5 3V3ZM11.2444 12.3519L9.335 10.3125L5.60812 12.35L9.7075 8L11.6644 10.0369L15.345 8L11.2444 12.3519Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.360c6dabd3ac068487431a231c4d44bc.svg";
export { ForwardRef as ReactComponent };